// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ManufacturerDetail_wrapper__1hWHi"};